/* ========================================================================== *\
    Autoplay
/* ========================================================================== */
export const STOP_AUTOPLAY = 'STOP_AUTOPLAY';
export const START_AUTOPLAY = 'START_AUTOPLAY';
export const QUIT_AUTOPLAY = 'QUIT_AUTOPLAY';
export const AUTOPLAY_NEXT_ITEM = 'AUTOPLAY_NEXT_ITEM';
export const RESTART_AUTOPLAY = 'RESTART_AUTOPLAY';

/* ========================================================================== *\
    PAGING
/* ========================================================================== */
export const YEAR_SELECTED = 'YEAR_SELECTED';
export const YEAR_CHANGED = 'YEAR_CHANGED';

/* ========================================================================== *\
    MARKERS
/* ========================================================================== */
export const MARKERS_CHANGED = 'MARKERS_CHANGED';
export const MARKERS_PLACED = 'MARKERS_PLACED';
export const STOP_MARKERS_POPUP = 'STOP_MARKERS_POPUP';
export const MARKER_SELECTED = 'MARKER_SELECTED';
export const MARKER_DESELECTED = 'MARKER_DESELECTED';

/* ========================================================================== *\
    INFO BOX
/* ========================================================================== */
export const SHOW_INFO_BOX = 'SHOW_INFO_BOX';
export const HIDE_INFO_BOX = 'HIDE_INFO_BOX';
export const CHANGE_INFO_BOX = 'CHANGE_INFO_BOX';

export const ROW_OUT = 'ROW_OUT';
export const ROW_HOVER = 'ROW_HOVER';
export const ROW_CLICKED = 'ROW_CLICKED';

export const SIDEBAR_CLOSED = 'SIDEBAR_CLOSED';
export const OPEN_SIDEBAR = 'OPEN_SIDEBAR';
export const SIDEBAR_OPENED = 'SIDEBAR_OPENED';

export const FILTER_OPENED = 'FILTER_OPENED';
export const SEARCH_OPENED = 'SEARCH_OPENED';
export const SEARCH_ENTERED = 'SEARCH_ENTERED';